import PhotographerCard from './PhotographerCard';

const PhotographerGrid = ({ photographers, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {[...Array(6)]?.map((_, index) => (
          <div key={index} className="bg-card rounded-xl overflow-hidden shadow-warm animate-pulse">
            <div className="h-48 md:h-56 lg:h-64 bg-muted"></div>
            <div className="p-4 md:p-5 lg:p-6">
              <div className="flex items-start justify-between gap-3 mb-3">
                <div className="flex-1 space-y-2">
                  <div className="h-6 bg-muted rounded w-3/4"></div>
                  <div className="h-4 bg-muted rounded w-1/2"></div>
                </div>
                <div className="w-12 h-12 md:w-14 md:h-14 bg-muted rounded-full"></div>
              </div>
              <div className="flex gap-2 mb-3">
                <div className="h-6 bg-muted rounded w-20"></div>
                <div className="h-6 bg-muted rounded w-20"></div>
              </div>
              <div className="h-4 bg-muted rounded w-full mb-4"></div>
              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div className="h-8 bg-muted rounded w-24"></div>
                <div className="h-10 bg-muted rounded w-28"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (photographers?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-warm p-8 md:p-12 lg:p-16 text-center">
        <div className="w-20 h-20 md:w-24 md:h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 md:w-12 md:h-12 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
          لم يتم العثور على مصورين
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          لم نتمكن من العثور على مصورين يطابقون معايير البحث الخاصة بك. جرب تعديل الفلاتر أو البحث بكلمات مختلفة.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      {photographers?.map((photographer, index) => (
        <PhotographerCard
          key={photographer?.id}
          photographer={photographer}
          priority={index < 6}
        />
      ))}
    </div>
  );
};

export default PhotographerGrid;